import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
export var ErrorMessage = function ErrorMessage(_ref) {
  var _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      displayNotes = _ref.displayNotes;
  return React.createElement(Fragment, null, touched && error && React.createElement('span', {
    className: 'error-msg'
  }, error, '\xA0'), displayNotes && React.createElement('span', null, displayNotes));
};

var FieldWrap = function FieldWrap(_ref2) {
  var children = _ref2.children,
      meta = _ref2.meta,
      displayNotes = _ref2.displayNotes;
  return React.createElement('div', {
    className: 'row'
  }, React.createElement('div', {
    className: "col-xs-12 col-sm-6 ".concat(meta.touched && meta.error ? 'error' : '')
  }, children), React.createElement('div', {
    className: 'col-xs-12 col-sm-6'
  }, React.createElement(ErrorMessage, {
    meta: meta,
    displayNotes: displayNotes
  })));
};

ErrorMessage.propTypes = {
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool
  }).isRequired,
  displayNotes: PropTypes.string
};
FieldWrap.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool
  }).isRequired,
  displayNotes: PropTypes.string
};
export default FieldWrap;